(() => {
  const productBtn = document.querySelector("#device-selector-btn"); // page produit
  const collectionWrap = document.querySelector("#collection-device-selector"); // page collection
  const collectionBtn = document.querySelector("#collection-device-selector-btn");
  const landingBtn = document.querySelector("#landing-device-selector-btn"); // landing page

  if (!productBtn && !(collectionWrap && collectionBtn) && !landingBtn) return;

  const endpoint = "https://zanae.shop/api/2026-01/graphql.json";
  const token = "15887e89e8d70805429609980c7ea24c";

  // Caches séparés
  let productCache = null;     // { items, grouped } avec items = produits
  let collectionCache = null;  // { items, grouped } avec items = devices

  // ---- DOM global (injecté dans <body>) pour éviter les problèmes de stacking context ----
  function ensureDeviceSelectorDOM() {
    let overlay = document.getElementById("device-selector-overlay");
    let modalWrap = document.getElementById("device-selector-modal-wrap");
    let modal = document.getElementById("device-selector-modal");

    if (overlay && modalWrap && modal) {
      return { overlay, modalWrap, modal };
    }

    overlay = document.createElement("div");
    overlay.id = "device-selector-overlay";
    overlay.style.display = "none";

    modalWrap = document.createElement("div");
    modalWrap.id = "device-selector-modal-wrap";
    modalWrap.style.display = "none";

    modalWrap.innerHTML = `
      <div id="device-selector-modal" role="dialog" aria-modal="true" aria-labelledby="device-selector-title">
        <div class="device-selector-header">
          <h2 id="device-selector-title">Choisir un téléphone</h2>
          <button type="button" id="device-selector-close" aria-label="Fermer">✕</button>
        </div>

        <input
          id="device-selector-search"
          type="search"
          placeholder="Rechercher un modèle…"
          autocomplete="off"
        />

        <div id="device-selector-list"><!-- rempli en JS --></div>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(modalWrap);

    modal = modalWrap.querySelector("#device-selector-modal");
    return { overlay, modalWrap, modal };
  }

  const { overlay, modalWrap, modal } = ensureDeviceSelectorDOM();
  const closeBtn = modalWrap.querySelector("#device-selector-close");
  const listEl = modalWrap.querySelector("#device-selector-list");
  const searchEl = modalWrap.querySelector("#device-selector-search");

  function openModal(activeBtn) {
    overlay.style.display = "block";
    modalWrap.style.display = "flex";
    document.body.style.overflow = "hidden";
    if (activeBtn) activeBtn.setAttribute("aria-expanded", "true");
    searchEl.value = "";
    // Sur mobile le focus déclenche le clavier et pousse la modale hors écran
    if (!("ontouchstart" in window)) searchEl.focus();
  }

  function closeModal() {
    overlay.style.display = "none";
    modalWrap.style.display = "none";
    document.body.style.overflow = "";
    // remet aria-expanded sur les boutons potentiels
    productBtn?.setAttribute("aria-expanded", "false");
    collectionBtn?.setAttribute("aria-expanded", "false");
  }

  function byKey(fields, key) {
    return (fields || []).find((f) => f.key === key)?.value || null;
  }

  function sortAndGroup(items) {
    items.sort((a, b) => {
      if ((a.brandPrio ?? 999) !== (b.brandPrio ?? 999)) return (a.brandPrio ?? 999) - (b.brandPrio ?? 999);

      const bn = (a.brandName || "").localeCompare(b.brandName || "", "fr", { sensitivity: "base" });
      if (bn !== 0) return bn;

      const ad = a.releaseDate ? Date.parse(a.releaseDate) : 0;
      const bd = b.releaseDate ? Date.parse(b.releaseDate) : 0;
      if (ad !== bd) return bd - ad;

      return (a.deviceName || "").localeCompare(b.deviceName || "", "fr", { sensitivity: "base" });
    });

    const grouped = items.reduce((acc, it) => {
      (acc[it.brandName] ||= []).push(it);
      return acc;
    }, {});

    return { items, grouped };
  }

  /**
   * Render générique
   * @param {{items: any[], grouped: Record<string, any[]>}} payload
   * @param {(item:any)=>void} onPick
   * @param {(item:any)=>string} getActionValue
   */
  function render(payload, onPick, getActionValue, currentGid) {
    const { grouped, items } = payload;
    const q = (searchEl.value || "").toLowerCase().trim();

    // Trier sections par priorité (ordre) puis nom
    const brandPrioMap = (items || []).reduce((acc, it) => {
      const p = it.brandPrio ?? 999;
      acc[it.brandName] = Math.min(acc[it.brandName] ?? 999, p);
      return acc;
    }, {});

    const brandNames = Object.keys(grouped).sort((a, b) => {
      const ap = brandPrioMap[a] ?? 999;
      const bp = brandPrioMap[b] ?? 999;
      if (ap !== bp) return ap - bp;
      return a.localeCompare(b, "fr", { sensitivity: "base" });
    });

    const brandsHtml = brandNames
      .map((brand) => {
        const brandItems = grouped[brand] || [];
        const filtered = !q ? brandItems : brandItems.filter((p) => (p.deviceName || "").toLowerCase().includes(q));
        if (!filtered.length) return "";

        const list = filtered
          .map((p) => {
            const v = getActionValue(p);
            const selected = currentGid && v === currentGid;
            return `
              <button class="device-selector-item${selected ? " device-selector-item--selected" : ""}" type="button" data-value="${encodeURIComponent(v)}">
                <span>${p.deviceName}</span>${selected ? `<span class="device-selector-selected-badge">Sélectionné</span>` : ""}
              </button>
            `;
          })
          .join("");

        return `
          <div class="device-selector-brand">
            <div class="device-selector-brand-title">${brand}</div>
            <div class="device-selector-brand-list">${list}</div>
          </div>
        `;
      })
      .join("");

    const resetHtml = !q
      ? `<button class="device-selector-item device-selector-item--reset" type="button"><span>Tous les modèles</span></button>`
      : "";

    listEl.innerHTML = resetHtml + (brandsHtml || `<div style="padding:8px 2px;">Aucun résultat</div>`);

    const resetBtn = listEl.querySelector(".device-selector-item--reset");
    if (resetBtn) resetBtn.addEventListener("click", () => onPick(null));

    listEl.querySelectorAll(".device-selector-item:not(.device-selector-item--reset)").forEach((el) => {
      el.addEventListener("click", () => {
        const raw = el.dataset.value ? decodeURIComponent(el.dataset.value) : "";
        const item = (payload.items || []).find((x) => getActionValue(x) === raw);
        if (item) onPick(item);
      });
    });
  }

  // Fiche à ouvrir pour un device : un tag collection_* peut couvrir plusieurs
  // looks (ex. collection_398_L = 5 looks Harmonie, sans couleur_produit), donc
  // on reste d'abord sur le même produit (handle sans « -pour-iphone-… »), puis
  // sur la même couleur, sinon le premier produit du device.
  function pickTargetForDevice(allProducts, deviceGid, currentHandle, currentCouleurGid) {
    const forDevice = (allProducts || []).filter((p) => p.deviceGid === deviceGid);
    const base = (currentHandle || "").replace(/-pour-iphone-.*$/, "");
    const sameBase = base ? forDevice.filter((p) => p.handle.replace(/-pour-iphone-.*$/, "") === base) : [];
    const pool = sameBase.length ? sameBase : forDevice;
    const colorMatch = currentCouleurGid ? pool.find((p) => p.couleurGid === currentCouleurGid) : null;
    return colorMatch || pool[0] || null;
  }

  async function storefrontFetch(query, variables) {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token,
      },
      body: JSON.stringify({ query, variables }),
    });
    return res.json();
  }

  // =========================================================
  // PRODUCT: load by tag (ton comportement actuel)
  // =========================================================
  async function loadProductsForTag(collectionTag) {
    if (!collectionTag) {
      const empty = sortAndGroup([]);
      empty.allProducts = [];
      return empty;
    }
    if (productCache) return productCache;

    const query = `
      query($q: String!) {
        products(first: 250, query: $q) {
          edges {
            node {
              title
              handle
              couleurProduit: metafield(namespace:"custom", key:"couleur_produit") {
                reference { ... on Metaobject { id } }
              }
              device: metafield(namespace:"custom", key:"device") {
                reference {
                  ... on Metaobject {
                    id
                    fields { key value }
                    marqueRef: field(key: "marque") {
                      reference {
                        ... on Metaobject { fields { key value } }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

    const json = await storefrontFetch(query, { q: `tag:${collectionTag}` });

    const allProducts = (json.data?.products?.edges || [])
      .map((e) => {
        const n = e.node;
        const dev = n.device?.reference;
        const devFields = dev?.fields || [];

        const deviceName = byKey(devFields, "nom") || n.title;
        const deviceGid = dev?.id || null;
        const releaseDate = byKey(devFields, "date_de_sortie");

        const brandFields = dev?.marqueRef?.reference?.fields || [];
        const brandName = byKey(brandFields, "nom") || "Autres";
        const brandPrio = parseInt(byKey(brandFields, "ordre") || "999", 10) || 999;

        const couleurGid = n.couleurProduit?.reference?.id || null;

        return {
          handle: n.handle,
          deviceName,
          deviceGid,
          releaseDate,
          brandName,
          brandPrio,
          couleurGid,
        };
      })
      .filter((p) => p.handle && p.deviceGid);

    // Dédupliquer par deviceGid pour l'affichage (un seul item par device)
    const deviceMap = new Map();
    for (const p of allProducts) {
      if (!deviceMap.has(p.deviceGid)) deviceMap.set(p.deviceGid, p);
    }

    const result = sortAndGroup(Array.from(deviceMap.values()));
    result.allProducts = allProducts;

    productCache = result;
    return productCache;
  }

  // =========================================================
  // COLLECTION: load devices available in this collection
  // =========================================================
  async function loadDevicesForCollection(handle) {
    if (collectionCache) return collectionCache;

    const query = `
      query($handle: String!) {
        collectionByHandle(handle: $handle) {
          products(first: 250) {
            nodes {
              device: metafield(namespace:"custom", key:"device") {
                reference {
                  ... on Metaobject {
                    id
                    fields { key value }
                    marqueRef: field(key: "marque") {
                      reference {
                        ... on Metaobject { fields { key value } }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

    const json = await storefrontFetch(query, { handle });

    const raw = (json.data?.collectionByHandle?.products?.nodes || [])
      .map((p) => p.device?.reference)
      .filter(Boolean);

    // Dedup par GID
    const map = new Map();
    for (const dev of raw) {
      if (!dev?.id) continue;
      if (map.has(dev.id)) continue;

      const deviceName = byKey(dev.fields, "nom") || "";
      const releaseDate = byKey(dev.fields, "date_de_sortie");

      const brandFields = dev?.marqueRef?.reference?.fields || [];
      const brandName = byKey(brandFields, "nom") || "Autres";
      const brandPrio = parseInt(byKey(brandFields, "ordre") || "999", 10) || 999;

      map.set(dev.id, {
        deviceGid: dev.id,
        deviceName,
        releaseDate,
        brandName,
        brandPrio,
      });
    }

    collectionCache = sortAndGroup(Array.from(map.values()));
    return collectionCache;
  }

  function setCollectionButtonValue(text) {
    const valueEl = collectionBtn?.querySelector(".device-selector-value");
    if (valueEl) valueEl.textContent = text;
  }

  const DEVICE_STORAGE_KEY = "ds_last_device";

  function applyCollectionDeviceFilter(deviceGid, deviceName) {
    const url = new URL(window.location.href);
    const handle = collectionWrap?.dataset.collectionHandle || "";
    if (deviceGid) {
      url.searchParams.set("filter.p.m.custom.device", deviceGid);
      try { localStorage.setItem(DEVICE_STORAGE_KEY, JSON.stringify({ gid: deviceGid, name: deviceName })); } catch (_) {}
      try { sessionStorage.removeItem("ds_cleared_" + handle); } catch (_) {}
    } else {
      url.searchParams.delete("filter.p.m.custom.device");
      try { localStorage.removeItem(DEVICE_STORAGE_KEY); } catch (_) {}
      try { sessionStorage.setItem("ds_cleared_" + handle, "1"); } catch (_) {}
    }
    window.location.href = url.toString();
  }

  // =========================================================
  // Wire: PRODUCT button
  // =========================================================
  if (productBtn) {
    const collectionTag = productBtn.dataset.collectionTag;

    // Préchargement dès l'ouverture de la page
    loadProductsForTag(collectionTag).catch(() => {});

    productBtn.addEventListener("click", async () => {
      if (window.zanaeTrack) zanaeTrack("iphone_selector_opened_product", { selector_source: "product" });
      openModal(productBtn);
      listEl.textContent = "Chargement…";

      const payload = await loadProductsForTag(collectionTag);
      const currentHandle = productBtn.dataset.currentHandle || "";
      const currentDeviceGid = (payload.allProducts || []).find((p) => p.handle === currentHandle)?.deviceGid || null;
      const currentCouleurGid = (payload.allProducts || []).find((p) => p.handle === currentHandle)?.couleurGid || null;

      render(
        payload,
        (item) => {
          if (item && window.zanaeTrack) zanaeTrack("iphone_model_selected", { model: item.deviceName, selector_source: "product" });
          if (item) { try { localStorage.setItem(DEVICE_STORAGE_KEY, JSON.stringify({ gid: item.deviceGid, name: item.deviceName })); } catch (_) {} }
          const target = pickTargetForDevice(payload.allProducts, item.deviceGid, currentHandle, currentCouleurGid) || item;
          window.location.href = `/products/${target.handle}`;
        },
        (item) => item.deviceGid,
        currentDeviceGid
      );
    });

    // === Routing par device : ouverture auto si device inconnu, redirection si device connu ===
    (async function deviceAwareInit() {
      let userDevice = null;
      try { const c = JSON.parse(localStorage.getItem(DEVICE_STORAGE_KEY) || "{}"); if (c.gid) userDevice = c; } catch (_) {}

      // Comportement 1 : device user inconnu -> ouvrir le sélecteur (1x par session)
      if (!userDevice) {
        try { if (sessionStorage.getItem("ds_autoopen_done") === "1") return; } catch (_) {}
        const open = () => {
          try { sessionStorage.setItem("ds_autoopen_done", "1"); } catch (_) {}
          productBtn.click();
        };
        if (document.readyState === "complete") open();
        else window.addEventListener("load", open, { once: true });
        return;
      }

      // Comportement 2 : device user connu -> rediriger vers la variante de son device (même couleur si dispo)
      const payload = await loadProductsForTag(collectionTag);
      const currentHandle = productBtn.dataset.currentHandle || "";
      const cur = (payload.allProducts || []).find((p) => p.handle === currentHandle);
      if (!cur || !cur.deviceGid || cur.deviceGid === userDevice.gid) return;
      const target = pickTargetForDevice(payload.allProducts, userDevice.gid, currentHandle, cur.couleurGid);
      if (target && target.handle !== currentHandle) window.location.replace("/products/" + target.handle);
    })();
  }

  // =========================================================
  // Wire: COLLECTION button + prefill (point 3)
  // =========================================================
  if (collectionWrap && collectionBtn) {
    const collectionHandle = collectionWrap.dataset.collectionHandle || "";
    const currentDeviceGid = new URL(window.location.href).searchParams.get("filter.p.m.custom.device") || "";

    // prefill immédiat depuis localStorage (évite le flash "Tous les modèles")
    if (currentDeviceGid) {
      try {
        const cached = JSON.parse(localStorage.getItem(DEVICE_STORAGE_KEY) || "{}");
        if (cached.gid === currentDeviceGid && cached.name) {
          setCollectionButtonValue(cached.name);
        }
      } catch (_) {}
    }

    // prefill async de secours (si localStorage vide ou GID différent)
    loadDevicesForCollection(collectionHandle)
      .then((payload) => {
        if (!currentDeviceGid) return;
        const hit = payload.items.find((x) => x.deviceGid === currentDeviceGid);
        if (hit?.deviceName) setCollectionButtonValue(hit.deviceName);
      })
      .catch(() => {});

    collectionBtn.addEventListener("click", async () => {
      openModal(collectionBtn);
      listEl.textContent = "Chargement…";

      const payload = await loadDevicesForCollection(collectionHandle);

      render(
        payload,
        (item) => {
          applyCollectionDeviceFilter(item ? item.deviceGid : null, item ? item.deviceName : null);
        },
        (item) => item.deviceGid,
        currentDeviceGid
      );
    });

    // === Collection : ouverture auto du sélecteur si device inconnu (1x/session) ===
    // (le device connu est déjà auto-filtré côté serveur par main-collection.liquid)
    (function collectionAutoOpen() {
      let userDevice = null;
      try { const c = JSON.parse(localStorage.getItem(DEVICE_STORAGE_KEY) || "{}"); if (c.gid) userDevice = c; } catch (_) {}
      if (userDevice) return; // device connu -> géré server-side
      try { if (sessionStorage.getItem("ds_autoopen_done") === "1") return; } catch (_) {}
      const open = () => {
        try { sessionStorage.setItem("ds_autoopen_done", "1"); } catch (_) {}
        collectionBtn.click();
      };
      if (document.readyState === "complete") open();
      else window.addEventListener("load", open, { once: true });
    })();
  }

  // =========================================================
  // Wire: LANDING PAGE button
  // =========================================================
  if (landingBtn) {
    const collectionTag = landingBtn.dataset.collectionTag;

    // Préchargement
    loadProductsForTag(collectionTag).catch(() => {});

    landingBtn.addEventListener("click", async () => {
      if (window.zanaeTrack) zanaeTrack("iphone_selector_opened_product", { selector_source: "landing" });
      openModal(landingBtn);
      listEl.textContent = "Chargement…";

      const payload = await loadProductsForTag(collectionTag);

      let currentDeviceGid = null;
      try {
        const cached = JSON.parse(localStorage.getItem(DEVICE_STORAGE_KEY) || "{}");
        if (cached.gid) currentDeviceGid = cached.gid;
      } catch (_) {}

      render(
        payload,
        (item) => {
          if (!item) { closeModal(); return; }
          if (window.zanaeTrack) zanaeTrack("iphone_model_selected", { model: item.deviceName, selector_source: "landing" });
          const allForDevice = (payload.allProducts || []).filter((p) => p.deviceGid === item.deviceGid);
          const target = allForDevice[0];
          // Tag absent ou aucun produit pour ce device -> repli sur la home
          if (!target) { window.location.href = "/"; return; }
          try { localStorage.setItem(DEVICE_STORAGE_KEY, JSON.stringify({ gid: item.deviceGid, name: item.deviceName })); } catch (_) {}
          window.location.href = `/products/${target.handle}`;
        },
        (item) => item.deviceGid,
        currentDeviceGid
      );
    });

    // ---- CTA sticky : réaffiche le bouton en bas de l'écran quand l'original sort du viewport ----
    const stickyBar = document.createElement("div");
    stickyBar.className = "landing-device-selector-sticky";
    const stickyBtn = landingBtn.cloneNode(true);
    stickyBtn.id = "landing-device-selector-sticky-btn";
    // retire les classes propres au contexte du hero (couleurs/marges overlay)
    stickyBtn.classList.remove("text-overlay__button", "button-row__btn");
    stickyBtn.setAttribute("aria-expanded", "false");
    stickyBtn.addEventListener("click", () => landingBtn.click());
    stickyBar.appendChild(stickyBtn);
    document.body.appendChild(stickyBar);

    if ("IntersectionObserver" in window) {
      const stickyIO = new IntersectionObserver(
        (entries) => {
          // resynchronise le libellé au cas où la valeur a changé
          const src = landingBtn.querySelector(".device-selector-value");
          const dst = stickyBtn.querySelector(".device-selector-value");
          if (src && dst) dst.textContent = src.textContent;
          stickyBar.classList.toggle("is-visible", !entries[0].isIntersecting);
        },
        { threshold: 0 }
      );
      stickyIO.observe(landingBtn);
    }
  }

  // =========================================================
  // Common events
  // =========================================================
  modalWrap.addEventListener("click", (e) => {
    if (!modal.contains(e.target)) closeModal();
  });
  closeBtn.addEventListener("click", closeModal);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeModal();
  });

  // =========================================================
  // LOOKS: swap look products for the current device equivalent
  // =========================================================
  const looksTagCache = new Map();

  async function loadLooksForTag(tag) {
    if (looksTagCache.has(tag)) return looksTagCache.get(tag);

    const query = `
      query($q: String!) {
        products(first: 250, query: $q) {
          edges {
            node {
              handle
              device: metafield(namespace:"custom", key:"device") {
                reference { ... on Metaobject { id } }
              }
            }
          }
        }
      }
    `;

    const json = await storefrontFetch(query, { q: `tag:${tag}` });
    const products = (json.data?.products?.edges || [])
      .map((e) => ({
        handle: e.node.handle,
        deviceGid: e.node.device?.reference?.id || null,
      }))
      .filter((p) => p.handle && p.deviceGid);

    looksTagCache.set(tag, products);
    return products;
  }

  async function initLooksDeviceSwap() {
    const containers = document.querySelectorAll("[data-looks-container]");
    if (!containers.length || !productBtn) return;

    const collectionTag = productBtn.dataset.collectionTag;
    const currentHandle = productBtn.dataset.currentHandle;

    let currentDeviceGid = null;
    try {
      const payload = await loadProductsForTag(collectionTag);
      currentDeviceGid = (payload.allProducts || []).find((p) => p.handle === currentHandle)?.deviceGid || null;
    } catch (_) {}

    if (!currentDeviceGid) return;

    const cards = Array.from(containers).flatMap((c) => Array.from(c.querySelectorAll("[data-look-tag][data-look-handle]")));

    await Promise.all(
      Array.from(cards).map(async (card) => {
        const lookTag = card.dataset.lookTag;
        const lookHandle = card.dataset.lookHandle;
        if (!lookTag) return;

        try {
          const lookProducts = await loadLooksForTag(lookTag);
          const candidates = lookProducts.filter((p) => p.deviceGid === currentDeviceGid);
          // Un tag collection_* peut couvrir plusieurs looks (ex. collection_392_L = 5 looks
          // « campus ») : on identifie le look par son préfixe de handle
          // (<look>-look-complet-pour-iphone-<device>) pour ne pas swapper vers un autre look.
          const lookBase = lookHandle.replace(/-pour-iphone-.*$/, "");
          const sameLook = candidates.filter((p) => p.handle === lookBase || p.handle.startsWith(lookBase + "-pour-iphone-"));
          const match = sameLook[0] || (candidates.length === 1 ? candidates[0] : null);
          if (!match || match.handle === lookHandle) return;

          const resp = await fetch(`/products/${match.handle}.js`);
          if (!resp.ok) return;
          const data = await resp.json();

          card.querySelectorAll('a[href*="/products/"]').forEach((a) => { a.href = data.url; });

          if (data.featured_image) {
            card.querySelectorAll("img").forEach((img) => {
              img.src = data.featured_image;
              img.removeAttribute("srcset");
              img.removeAttribute("data-srcset");
              if (data.title) img.alt = data.title;
            });
            card.querySelectorAll("source").forEach((s) => { s.srcset = data.featured_image; });
          }

          const titleEl = card.querySelector("[class*='title'], h3, h2");
          if (titleEl) titleEl.textContent = data.title;

          card.dataset.lookHandle = match.handle;
        } catch (_) {}
      })
    );
  }

  initLooksDeviceSwap().catch(() => {});

  // Auto-open via ?open_selector=1 (pour les landing pages pub)
  if (new URL(window.location.href).searchParams.has("open_selector")) {
    const autoBtn = collectionBtn || productBtn;
    if (autoBtn) autoBtn.click();
  }

  searchEl.addEventListener("input", async () => {
    // Re-render selon le contexte ouvert (produit ou collection)
    // On détecte selon la présence des boutons et caches disponibles.
    const isProductOpen = productBtn && productBtn.getAttribute("aria-expanded") === "true";
    const isCollectionOpen = collectionBtn && collectionBtn.getAttribute("aria-expanded") === "true";

    if (isProductOpen && productCache) {
      const currentHandle = productBtn?.dataset.currentHandle || "";
      const currentDeviceGid = (productCache.allProducts || []).find((p) => p.handle === currentHandle)?.deviceGid || null;
      const currentCouleurGid = (productCache.allProducts || []).find((p) => p.handle === currentHandle)?.couleurGid || null;
      render(
        productCache,
        (item) => {
          const target = pickTargetForDevice(productCache.allProducts, item.deviceGid, currentHandle, currentCouleurGid) || item;
          window.location.href = `/products/${target.handle}`;
        },
        (item) => item.deviceGid,
        currentDeviceGid
      );
      return;
    }

    if (isCollectionOpen && collectionCache) {
      const activeDeviceGid = new URL(window.location.href).searchParams.get("filter.p.m.custom.device") || null;
      render(
        collectionCache,
        (item) => applyCollectionDeviceFilter(item ? item.deviceGid : null, item ? item.deviceName : null),
        (item) => item.deviceGid,
        activeDeviceGid
      );
    }
  });
})();